if (!customElements.get('popup-cupom')) {
  customElements.define(
    'popup-cupom',
    class PopupCupom extends HTMLElement {
      constructor() {
        super();
        this.storageKey = 'bnp-popup-cupom';
        this.subscribed = false;
        this.onKeyUp = (event) => {
          if (event.code === 'Escape') this.close();
        };
      }

      connectedCallback() {
        this.querySelectorAll('[data-popup-close]').forEach((el) =>
          el.addEventListener('click', () => this.close())
        );

        const copyButton = this.querySelector('[data-popup-copy]');
        if (copyButton) {
          copyButton.addEventListener('click', () => {
            navigator.clipboard
              .writeText(copyButton.dataset.popupCopy)
              .then(() => {
                copyButton.textContent = 'Copiado!';
              })
              .catch(() => {});
          });
        }

        const forced = this.querySelector('[data-popup-force]');
        if (forced) {
          if (forced.dataset.popupForce === 'success') {
            this.subscribed = true;
            this.saveState('subscribed');
          }
          this.open();
          return;
        }

        if (window.Shopify && window.Shopify.designMode) {
          document.addEventListener('shopify:section:select', (event) => {
            if (event.detail.sectionId === this.dataset.sectionId) this.open();
          });
          document.addEventListener('shopify:section:deselect', (event) => {
            if (event.detail.sectionId === this.dataset.sectionId) this.close(true);
          });
          return;
        }

        if (!this.shouldShow()) return;
        const delay = (parseInt(this.dataset.delay, 10) || 15) * 1000;
        this.timer = setTimeout(() => this.open(), delay);
      }

      disconnectedCallback() {
        if (this.timer) clearTimeout(this.timer);
        document.removeEventListener('keyup', this.onKeyUp);
      }

      shouldShow() {
        try {
          const raw = localStorage.getItem(this.storageKey);
          if (!raw) return true;
          const state = JSON.parse(raw);
          if (state.status === 'subscribed') return false;
          const reshowDays = parseInt(this.dataset.reshowDays, 10) || 7;
          return Date.now() - state.ts > reshowDays * 86400000;
        } catch (error) {
          return true;
        }
      }

      saveState(status) {
        try {
          localStorage.setItem(this.storageKey, JSON.stringify({ status: status, ts: Date.now() }));
        } catch (error) {
          // localStorage indisponível (ex.: modo privado) — o pop-up apenas reaparece
        }
      }

      open() {
        this.removeAttribute('hidden');
        document.body.classList.add('overflow-hidden');
        document.addEventListener('keyup', this.onKeyUp);
        const focusTarget = this.querySelector('[data-popup-force], input:not([type="hidden"])');
        if (focusTarget) focusTarget.focus();
      }

      close(fromEditor) {
        if (this.timer) clearTimeout(this.timer);
        this.setAttribute('hidden', '');
        document.body.classList.remove('overflow-hidden');
        document.removeEventListener('keyup', this.onKeyUp);
        if (!fromEditor) this.saveState(this.subscribed ? 'subscribed' : 'dismissed');
      }
    }
  );
}
